import type { FC } from 'react';
import cn from 'classnames';
import Pagination from '@wix/da-shared-react/pkg/Pagination';
import generatePaginationUrl from '../../../../utils/generatePaginationUrl';

import s from './PagedPagination.scss';

export interface Props {
  currentPage: number;
  totalPages: number;
  requestUrl: string;
  className?: string;
  paginationClassName?: string;
  showPageNumbers?: boolean;
}

const PagedPagination: FC<Props> = ({
  currentPage,
  totalPages,
  requestUrl,
  className,
  paginationClassName,
  showPageNumbers = true,
}) => {
  return (
    <div className={cn(s['root'], className)}>
      <Pagination
        className={paginationClassName}
        currentPage={currentPage}
        totalPages={totalPages}
        showPageNumbers={showPageNumbers}
        getPageUrl={page => generatePaginationUrl(page, requestUrl)}
      />
    </div>
  );
};

PagedPagination.displayName = 'PagedPagination';

export default PagedPagination;
